export const getPages = (pageCount: number, currentPage: number, maxPages: number): number[] => {
  const lastIndex = pageCount - 1
  if (pageCount <= maxPages) {
    return [...Array(pageCount).keys()]
  } else if (currentPage + 1 <= maxPages / 2) {
    return [...Array(maxPages).keys()]
  } else if (lastIndex - currentPage <= maxPages / 2) {
    const pages: number[] = []
    for (let i = 0; i < maxPages; i++) {
      pages.push(lastIndex - i)
    }
    return pages.reverse()
  } else {
    let min = currentPage - (maxPages - 1) / 2
    let max = currentPage + (maxPages - 1) / 2
    if (maxPages % 2 == 0) {
      min = currentPage - (maxPages / 2 - 1)
      max = currentPage + maxPages / 2
    }
    const pages: number[] = []
    for (let i = min; i <= max; i++) {
      pages.push(i)
    }
    return pages
  }
}
